<template>
  <v-app class="view">

    <v-navigation-drawer
        :width="drawer_width"
        absolute
        class="nav fix-menu"
        permanent
        touchless
    >

      <v-card :class="{primary:activeMenu==='users'}" :to="'/admin'" class="pa-2" outlined tile>
        User
      </v-card>
      <v-card :class="{primary:activeMenu==='data'}" :to="'/data'" class="pa-2" outlined tile>
        Data
      </v-card>
      <v-card :class="{primary:activeMenu==='admin_setting'}" :to="'/admin_setting'" class="pa-2" outlined tile>
        Setting
      </v-card>

    </v-navigation-drawer>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card class="pa-8">
          <v-container>
            <v-row>
              <v-col>
                ซ่อมข้อมูลใบเสร็จที่ไม่เข้าระบบ
              </v-col>
              <v-col>
                <v-text-field

                    v-model="receipt_code"
                    class="login-input"
                    label="Code"
                    outlined
                    placeholder="RCVVAPJ-23010001"
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-btn :loading="isLoadReceipt" @click="force_receipt()">จ่ายแล้ว</v-btn>
              </v-col>
            </v-row>
            <v-row v-if="affected_record.length>0">
              <v-col>
                ออเดอร์ที่จ่ายแล้ว {{ affected_record.join(',') }}
              </v-col>
            </v-row>
          </v-container>
        </v-card>

      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0px;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

</style>
<script lang="ts">

import {SimpleResponse} from '@/models/Model'
import {UserConst} from '@/models/User'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import {DataArray} from '../models/Response'
import {User} from '../models/User'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy},
})
export default class ViewAdminData extends Vue {

  drawer_ratio = 0.15
  drawer_width = 200

  activeMenu = 'data'

  receipt_code = ''
  isLoadReceipt = false

  affected_record = []

  async force_receipt() {

    const url = '/api/receipt/force'
    this.isLoadReceipt = true
    try {
      let data = await Helper.post(url, {
        code: this.receipt_code,
      }).then<{ data: any }>(({data}) => data)

      console.log('res', data)

      if (data.success) {
        this.affected_record = data.affected_record
        this.$root.$emit('onSuccess', {message: data.message.toString()})
      } else {
        this.$root.$emit('onError', {message: data.message.toString()})
      }

    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }
    this.isLoadReceipt = false
  }

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)
  }
}
</script>
